import clsx from 'clsx';
import { useRef } from 'preact/hooks';
import { IconSource } from 'types/icons';
import { variationName } from 'utilities/css';

import { LazyImage } from 'components/LazyImage';

import styles from './Image.module.scss';

type Size = 'medium' | 'large';

interface ImageProps {
  /** Display image saving its aspect ratio */
  saveRatio?: boolean;
  source: string | IconSource;
  fallback?: string;
  alt: string;
  /** Size of the image */
  size?: Size;
  onLoad?: () => void;
  blurBackground?: boolean;
}

export function Image({
  saveRatio,
  source,
  fallback,
  alt,
  size,
  onLoad,
  blurBackground,
}: ImageProps) {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  if (!source) {
    return null;
  }

  const className = clsx(
    styles.Image,
    saveRatio && styles.saveRatio,
    size && styles[variationName('size', size)],
    blurBackground && styles.blurBackground,
  );

  const Icon = source;

  return (
    <div
      ref={wrapperRef}
      className={className}
      style={{
        '--background-image': blurBackground ? `url('${source}')` : 'none',
      }}
    >
      {typeof source === 'string' ? (
        <LazyImage
          wrapperRef={wrapperRef}
          fallback={fallback}
          src={source}
          alt={alt}
          onLoad={onLoad}
        />
      ) : (
        <Icon className={styles.Icon} aria-hidden="true" focusable="false" />
      )}
    </div>
  );
}
